import {getTodayReservationList, signReOrder, getTodayReservationStat} from "@/api";
import {ElMessageBox} from "element-plus";
import {message, getTodayDate} from "@/assets/utils/common";
import baseConfig from "@/api/config";
import {startReservationAutoRefresh, stopReservationAutoRefresh} from "@/assets/utils/reservationRefresh";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                cardPatientName: '',
                cardPatientPhone: '',
                reSerialNo: '',
                reStatus: '',
                isFree: ''
            },
            tableLoading: false,
            listRequestInFlight: false,
            tableData: [],
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            doctorInfo: null,
            reservationRefreshTimer: null,
            statData: {
                total: 0,
                waitSign: 0,
                waitVisit: 0,
                visiting: 0,
                done: 0,
                cancel: 0,
            },
        }
    },
    computed: {
        todayLabel() {
            const date = new Date();
            const m = date.getMonth() + 1;
            const d = date.getDate();
            const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
            const w = weekDays[date.getDay()];
            return `${m}月${d}日 星期${w}`;
        }
    },
    mounted() {
        setTimeout(() => {
            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
        }, 1000)
    },
    created() {
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        this.getTodayReservationStatInfo();
        this.getTodayReservationListInfo();
        startReservationAutoRefresh(this, () => {
            this.getTodayReservationStatInfo();
            this.getTodayReservationListInfo(true);
        });
    },
    beforeUnmount() {
        stopReservationAutoRefresh(this);
    },
    methods: {
        // 查询今日预约统计数据
        getTodayReservationStatInfo() {
            const data = {
                schDate: getTodayDate(),
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null,
            };
            getTodayReservationStat(data).then(res => {
                const rdata = res.data;
                if (rdata.code === 200 && rdata.data) {
                    const d = rdata.data;
                    this.statData = {
                        total: d.total || 0,
                        waitSign: d.waitSign || 0,
                        waitVisit: d.waitVisit || 0,
                        visiting: d.visiting || 0,
                        done: d.done || 0,
                        cancel: d.cancel || 0,
                    };
                    this.totalCount = d.total || 0;
                }
            }).catch(() => {});
        },

        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.cardPatientName = "";
            this.queryParams.cardPatientPhone = "";
            this.queryParams.reSerialNo = "";
            this.queryParams.reStatus = "";
            this.queryParams.isFree = "";
            this.queryParams.keyword = "";
            this.currentPage = 1;
            this.getTodayReservationListInfo();
        },

        // 点击统计卡片筛选预约列表
        filterByStatus(status, isFree = '') {
            this.queryParams.reStatus = status;
            this.queryParams.isFree = isFree;
            this.currentPage = 1;
            this.getTodayReservationListInfo();
        },

        // 切换分页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getTodayReservationListInfo();
        },

        // 切换分页
        handleSizeChange(val) {
            this.pageNums = val;
            this.getTodayReservationListInfo();
        },

        // 查询今日预约列表（silent=true 时为定时自动刷新，不清空表格、不显示 loading，避免面板闪烁）
        getTodayReservationListInfo(silent = false) {
            // 上一轮自动刷新请求尚未返回时跳过本轮，避免请求堆积
            if (silent && this.listRequestInFlight) return;
            if (!silent) {
                this.tableData = [];
                this.tableLoading = true;
            }
            this.listRequestInFlight = true;
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageNums,
                schDate: getTodayDate(),
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null,
                cardPatientPhone: this.queryParams.cardPatientPhone,
                cardPatientName: this.queryParams.cardPatientName,
                reSerialNo: this.queryParams.reSerialNo,
                reStatus: this.queryParams.reStatus,
                isFree: this.queryParams.isFree,
                //在途单按签到序（queue_seq）排，不传会被后端默认序覆盖
                queueOrder: '1',
            };
            getTodayReservationList(data).then(res => {
                const rdata = res.data;
                this.tableLoading = false;
                this.listRequestInFlight = false;
                if (rdata.code === 200) {
                    let rows = rdata.rows || [];
                    //按排队号（签到序）升序，未签到（无排队号）排最后、按预约时间兜底
                    rows.sort((a, b) => {
                        const seqA = a.queueSeq == null ? Number.MAX_SAFE_INTEGER : a.queueSeq;
                        const seqB = b.queueSeq == null ? Number.MAX_SAFE_INTEGER : b.queueSeq;
                        if (seqA !== seqB) {
                            return seqA - seqB;
                        }
                        return (a.reTime || '').localeCompare(b.reTime || '');
                    });
                    this.tableData = rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        let birYear = item.cardPatientBirth ? new Date(item.cardPatientBirth).getFullYear() : null;
                        let nowYear = new Date().getFullYear();
                        item.age = birYear ? parseInt(nowYear - birYear) : '--';
                        item.reTimeTypeText = item.reTimeType === 'am' ? '上午' : item.reTimeType === 'pm' ? '下午' : '晚上';
                        item.reStatusText = item.reStatus === '1' ? '待支付' : item.reStatus === '2' ?
                            '已完成' : item.reStatus === '3' ? '已失效' : item.reStatus === '4' ? '已取消' : item.reStatus === '5' ? '待就诊' : item.reStatus === '6' ? '就诊中' : item.reStatus === '7' ? '已过号' : item.reStatus === '8' ? '待签到' : '未知';
                        if (item.cardPatientSex === '0') {
                            item.sexText = '男';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.cardPatientSex === '1') {
                            item.sexText = '女';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.sexText = '未知';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                this.listRequestInFlight = false;
                // 静默刷新失败只记录，不弹错误提示，避免定时刷新反复弹窗
                if (silent) {
                    console.error("auto refresh failed:", error);
                } else {
                    message(error, "error");
                }
            });
        },

        // 签到
        handleSign(row) {
            const reId = row.reId;
            ElMessageBox.confirm('确定要签到？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
            }).then(() => {
                signReOrder(reId).then(res => {
                    if (res.code === 200) {
                        //后端签到时分配当天排队号，随签到结果回传
                        message(res.data ? "签到成功，排队" + res.data + "号" : "签到成功", "success");
                        this.getTodayReservationStatInfo();
                        this.getTodayReservationListInfo();
                    } else {
                        message(res.msg || "签到失败", "warning");
                        this.getTodayReservationStatInfo();
                        this.getTodayReservationListInfo();
                    }
                }).catch(error => {
                    message(error, "error");
                });
            }).catch(() => {});
        },

        // 接诊
        openMedical(row) {
            const patientInfo = {
                docId: null,
                patientId: null,
                idcard: null,
                avatarImg: null,
                name: row.cardPatientName,
                sex: row.cardPatientSex,
                age: row.age,
                phoneNumber: row.cardPatientPhone,
                identity: row.cardIdentity,
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null,
                bloodType: null,
                marryStatus: null,
                patientType: null,
                allergyHistory: null,
                firstVisitResult: null,
            };
            window.sessionStorage.removeItem("reservationPatient");
            window.sessionStorage.setItem("reservationPatient", JSON.stringify(patientInfo));
            this.$router.push({path: '/admin/clinictreat'});
            this.$store.state.adminleftnavnum = 'clinictreat';
        },
    }
}
